import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the TextSearchBarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'text-search-bar',
  templateUrl: 'text-search-bar.html',
  styleUrls: ['./text-search-bar.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class TextSearchBarComponent implements OnInit, OnDestroy {

  private inputText: String;
  private searchDone: boolean;
  private prevTime: number;
  private searchTerm: String;
  private waitTime: number = 1000; // time (ms) to wait for next keystroke
  private timer: any = 0;

  private clearSearchTextSubscription: any;

  constructor(private events: AppEventService) {
    this.searchDone = false;
  }

  handleTextInput(event: any) {
//    this.search();
    this.decideIfToSearch();
  }

  timeSearch() {
    this.clearTimer();
    console.log("text-search-bar - timing search");
    this.timer = setTimeout(() => {
    console.log("text-search-bar - launching search");
    // 'this' now correctly refers to the class instance containing inputText and events
    this.events.publish("search:textInput", this.inputText);
    this.timer = 0;
}, this.waitTime);
    console.log("text-search-bar - timer id = " + this.timer);
  }
  clearTimer() {
    if (this.timer != 0) {
      // already a timer running, kill it and restart
      clearTimeout(this.timer);
      let oldTimerId: number = this.timer;
      this.timer = 0;
      console.log("text-search-bar - cleared timer " + oldTimerId);
    }
  }
  decideIfToSearch() {
    if (this.inputText === "") {
      this.clearTimer();
      console.log("text-search-bar - no input: cancel text search");
      this.events.publish("search:textCancel");
      return;
    }
    if (this.inputText.length < 3) {
      this.clearTimer();
      console.log("text-search-bar - enter at least 3 characters before searching...");
      return;
    }
    else { // valid inputText
      this.searchTerm = this.inputText;
      this.timeSearch();
    }
  }
  search_obsolete() {
    console.log("text-search-bar - searching...");
    let timestamp = Date.now();

    if (this.inputText !== "") {
      if (this.inputText.length < 3) {
        console.log("text-search-bar - enter at least 3 characters before searching...");
        return;
      }
      if (this.searchDone) {
        //check diff between now and prevTime
        let timeDiff = Date.now() - this.prevTime;
        console.log("text-search-bar - time since last search: " + timeDiff);
        if (timeDiff < this.waitTime) {
          console.log("text-search-bar - we wait a certain time between subsequent search requests..., time diff was " + timeDiff);
          if (this.timer != 0) {
            // already a timer running, kill it and restart
            console.log("text-search-bar - killing previous timer after " + timeDiff + " ms");
            clearTimeout(this.timer);
            this.timer = 0;
          }
          this.searchTerm = this.inputText;
          this.timer = setTimeout(function() {
            console.log("text-search-bar - launching search");
            this.events.publish("search:textInput", this.inputText);
            this.timer = 0;
          }.bind(this), this.waitTime);
          return;
        }
      }
      this.prevTime = timestamp;
      this.searchDone = true;
      this.events.publish("search:textInput", this.inputText);
    } else {
      this.events.publish("search:textCancel");
    }
  }

  searchTimed() {
    console.log("text-search-bar - searchTimed: " + this.searchTerm);
    this.events.publish("search:textInput", this.searchTerm);
  }

  handleTextCancel(event: any) {
    this.events.publish("search:textCancel");
  }

  ngOnInit() {
    this.clearSearchTextSubscription = () => {
      console.log("text-search-bar - clearing text...");
      // this.inputText = ""; TODO no clearing needed only return to searchpage?
    };
    this.events.subscribe("navbar:searchpressed", this.clearSearchTextSubscription);
  }

  ngOnDestroy() {
    this.events.unsubscribe("navbar:searchpressed", this.clearSearchTextSubscription);
  }
}
